import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.modified = false
    // touch primary input i.e. devices with virtual keyboards phone, tablet, etc. will be covered by adding autocapitalize on input
    this.usesTouchPrimaryInput = window.matchMedia?.("(hover: none) and (pointer: coarse)").matches
  }

  input(event) {
    if (this.usesTouchPrimaryInput || this.modified) return

    if (event.inputType?.startsWith("delete")) {
      this.modified = true
      return
    }

    const input = event.target
    const value = input.value

    if (value.length === 1 && /^[a-z]$/.test(value)) {
      input.value = value.toUpperCase()
      return
    }

    if (value.length > 1) {
      this.modified = true
    }
  }
}
